export function addScrolledClass() {
    const body = document.body;
    let isScrolled = false;
    let isHovered = false;

    function updateScrolledClass() {
        if (isScrolled || isHovered) {
            body.classList.add('scrolled');
        } else {
            body.classList.remove('scrolled');
        }
    }

        function updateMenuVisibleClass() {
        if (isScrolled || isHovered) {
            body.classList.add('menu-open');
        } else {
            body.classList.remove('menu-open');
        }
    }

    window.addEventListener('scroll', () => {
        isScrolled = window.scrollY > 0;
        updateScrolledClass();
    });

    const navLists = document.querySelectorAll('.site-navigation__primary');

    navLists.forEach((navList) => {
        navList.addEventListener('mouseenter', () => {
            isHovered = true;
            updateMenuVisibleClass();
        });

        navList.addEventListener('mouseleave', () => {
            isHovered = false;
            updateMenuVisibleClass();
        });
    });
}
